import React from 'react'

const Controller = () => (
    <svg width="51" height="51" viewBox='0 0 51 51' fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25.5" cy="25.5" r="24.8" stroke="#000" strokeWidth="1.5"/><path stroke="#000" strokeWidth="1.5" d="M22.9 14.8v20.7M31.8 17v16.3M27.4 19.2V31M17.8 19.2V31M35.5 22.2v5.9"/></svg>
)

export default Controller